<div class="modal-header">
    <h4 class="modal-title">Adicionar Garantia</h4>
    <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()"></button>
  </div>
  <div class="modal-body">
    <label for="combo">Selecione uma garantia:</label>
    <select class="form-select" id="combo" [(ngModel)]="garantia">
        <option *ngFor="let valor of todosTiposOutrasGarantias" [ngValue]="valor">{{valor.descricao}}</option>
    </select>
    <div *ngIf="mensagemAviso" class="alert alert-warning">
        {{mensagemAviso}}
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
    <button class="btn btn-primary" (click)="salvar()">Salvar</button>
</div>